import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=37ae9e37&scoped=true&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae9e37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ae9e37')) {
      api.createRecord('37ae9e37', component.options)
    } else {
      api.reload('37ae9e37', component.options)
    }
    module.hot.accept("./documentList.vue?vue&type=template&id=37ae9e37&scoped=true&", function () {
      api.rerender('37ae9e37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionProjectMgr/projectMgr/components/documentList.vue"
export default component.exports